// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/conversion--src--checkouts--shipping.json";
import part1 from "./en/conversion--src--conversion--hsa--fields.json";
import part2 from "./en/conversion--src--conversion--hsa.json";
import part3 from "./en/email-builder--src--email-builder--builder--inspectors.json";
import part4 from "./en/merchant--support--app--src--gmail.json";
import part5 from "./en/merchant--support--app--src--setting--channel.json";
import part6 from "./en/merchant--support--app--src--setting--chat-flow.json";
import part7 from "./en/merchant--support--app--src--setting--general--components.json";
import part8 from "./en/merchant--support--app--src--setting--general.json";
import part9 from "./en/merchant--support--app--src--setting--rules--components.json";
import part10 from "./en/merchant--support--app--src--setting--rules--conditions.json";
import part11 from "./en/merchant--support--app--src--setting--rules--flow-editor--actions.json";
import part12 from "./en/merchant--support--app--src--setting--rules--flow-editor--conditions.json";
import part13 from "./en/merchant--support--app--src--setting--rules--flow-editor.json";
import part14 from "./en/merchant--support--app--src--setting--rules.json";
import part15 from "./en/merchant--support--app--src--setting.json";
import part16 from "./en/merchant--support--app--src--v2--components--timeline--events--rules-triggered.json";
import part17 from "./en/merchant--support--app--src--v2--filters.json";
import part18 from "./en/merchant--support--app--src--v2--hooks.json";
import part19 from "./en/merchant--support--app--src--v2--setting--macros.json";
import part20 from "./en/merchant--support--app--src--v2--setting--topics.json";
import part21 from "./en/shipping-claims--src--shipping-claims--columns.json";
import part22 from "./en/shipping-claims--src--shipping-claims--filters.json";
import part23 from "./en/shipping-claims--src--shipping-claims.json";
import part24 from "./en/src--accounts--wish-list.json";
import part25 from "./en/src--address-verification.json";
import part26 from "./en/src--advanced-filters--components.json";
import part27 from "./en/src--arbiter-components--alert.json";
import part28 from "./en/src--arbiter-components--audio.json";
import part29 from "./en/src--arbiter-components--bar-comparison.json";
import part30 from "./en/src--arbiter-components--buttons.json";
import part31 from "./en/src--arbiter-components--charts--chart-card.json";
import part32 from "./en/src--arbiter-components--charts--funnel-chart.json";
import part33 from "./en/src--arbiter-components--charts--heatmap.json";
import part34 from "./en/src--arbiter-components--charts--inline-sparkline.json";
import part35 from "./en/src--arbiter-components--charts--insights-breakdown.json";
import part36 from "./en/src--arbiter-components--charts--line-and-bar-chart.json";
import part37 from "./en/src--arbiter-components--charts--sankey-chart.json";
import part38 from "./en/src--arbiter-components--chat.json";
import part39 from "./en/src--arbiter-components--color-picker.json";
import part40 from "./en/src--arbiter-components--command-menu.json";
import part41 from "./en/src--arbiter-components--conversation-drawer.json";
import part42 from "./en/src--arbiter-components--date-picker--date-picker--components.json";
import part43 from "./en/src--arbiter-components--date-picker.json";
import part44 from "./en/src--arbiter-components--elevated-onboarding.json";
import part45 from "./en/src--arbiter-components--feature-notification.json";
import part46 from "./en/src--arbiter-components--file-upload.json";
import part47 from "./en/src--arbiter-components--filter-group.json";
import part48 from "./en/src--arbiter-components--filter-overflow.json";
import part49 from "./en/src--arbiter-components--finder.json";
import part50 from "./en/src--arbiter-components--icon-picker.json";
import part51 from "./en/src--arbiter-components--input.json";
import part52 from "./en/src--arbiter-components--integrations-card.json";
import part53 from "./en/src--arbiter-components--interactive-map.json";
import part54 from "./en/src--arbiter-components--list.json";
import part55 from "./en/src--arbiter-components--metric-item-tabs.json";
import part56 from "./en/src--arbiter-components--navigation--common.json";
import part57 from "./en/src--arbiter-components--navigation--primary.json";
import part58 from "./en/src--arbiter-components--navigation--secondary.json";
import part59 from "./en/src--arbiter-components--navigation.json";
import part60 from "./en/src--arbiter-components--notification.json";
import part61 from "./en/src--arbiter-components--oms.json";
import part62 from "./en/src--arbiter-components--order-summary.json";
import part63 from "./en/src--arbiter-components--page-header.json";
import part64 from "./en/src--arbiter-components--playbook.json";
import part65 from "./en/src--arbiter-components--progress-bar.json";
import part66 from "./en/src--arbiter-components--select-dropdown.json";
import part67 from "./en/src--arbiter-components--settings-card.json";
import part68 from "./en/src--arbiter-components--setup-checklist.json";
import part69 from "./en/src--arbiter-components--tables.json";
import part70 from "./en/src--arbiter-components--tabs.json";
import part71 from "./en/src--arbiter-components--walkthrough.json";
import part72 from "./en/src--arbiter-components.json";
import part73 from "./en/src--carrier.json";
import part74 from "./en/src--faq--customer-portal.json";
import part75 from "./en/src--filters.json";
import part76 from "./en/src--form-builder--inspectors.json";
import part77 from "./en/src--fulfillment--setting--carrier-accounts--carrier-forms.json";
import part78 from "./en/src--fulfillment--setting--carrier-accounts.json";
import part79 from "./en/src--merchant-homepage.json";
import part80 from "./en/src--onboarding.json";
import part81 from "./en/src--order-editing.json";
import part82 from "./en/src--reviews-form.json";
import part83 from "./en/src--roles.json";
import part84 from "./en/src--settings-elements--order.json";
import part85 from "./en/src--settings-rows.json";
import part86 from "./en/src--tracking-page-builder--blocks--game.json";
import part87 from "./en/src--tracking-page-builder--blocks--product-upsell.json";
import part88 from "./en/src--tracking-page-builder--blocks--tracking-details.json";
import part89 from "./en/src--tracking-page-builder--blocks.json";
import part90 from "./en/src--tracking-page-builder--builder--inspectors.json";
import part91 from "./en/src--tracking-page-builder--builder.json";
import part92 from "./en/src--tracking-page-builder.json";
import part93 from "./en/src.json";
import part94 from "./en/storybook--library--src--stories.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
  part7,
  part8,
  part9,
  part10,
  part11,
  part12,
  part13,
  part14,
  part15,
  part16,
  part17,
  part18,
  part19,
  part20,
  part21,
  part22,
  part23,
  part24,
  part25,
  part26,
  part27,
  part28,
  part29,
  part30,
  part31,
  part32,
  part33,
  part34,
  part35,
  part36,
  part37,
  part38,
  part39,
  part40,
  part41,
  part42,
  part43,
  part44,
  part45,
  part46,
  part47,
  part48,
  part49,
  part50,
  part51,
  part52,
  part53,
  part54,
  part55,
  part56,
  part57,
  part58,
  part59,
  part60,
  part61,
  part62,
  part63,
  part64,
  part65,
  part66,
  part67,
  part68,
  part69,
  part70,
  part71,
  part72,
  part73,
  part74,
  part75,
  part76,
  part77,
  part78,
  part79,
  part80,
  part81,
  part82,
  part83,
  part84,
  part85,
  part86,
  part87,
  part88,
  part89,
  part90,
  part91,
  part92,
  part93,
  part94,
);
